import { Component } from '@opten/compiler/metadata/component';
import { addClass } from '@opten/dom/add-class';
import { addClassFactory } from '@opten/dom/add-class-factory';
import { hasClass } from '@opten/dom/has-class';
import { removeClass, removeClassFactory } from '@opten/dom/remove-class';
import { debounce } from '@opten/reactive/debounce';

@Component({ className: 'js-tabdrop' })
export class TabDropComponent {
	private tabdrop: TabDrop;

	constructor(private element: HTMLElement) {
		this.tabdrop = new TabDrop(element);
	}
}

//import { TabDrop } from '@opten/tabdrop';
export class TabDrop {
	private itemHolder: HTMLElement;
	private tabdrop: HTMLElement;
	private children: HTMLElement[];
	private listChildren: HTMLElement[];

	constructor(private element: HTMLElement) {
		this.itemHolder = this.element.getElementsByClassName(
			'js-tabdrop-holder'
		)[0] as HTMLElement;
		this.tabdrop = this.element.getElementsByClassName(
			'js-tabdrop-element'
		)[0] as HTMLElement;
		this.children = Array.from(this.element.children) as HTMLElement[];
		this.listChildren = this.children.filter(
			(child) => !hasClass(child, 'js-tabdrop-element')
		);

		window.addEventListener(
			'resize',
			debounce(() => this.layout(), 100)
		);

		this.layout();
	}

	protected onTransform(element: HTMLElement): HTMLElement {
		return element.cloneNode(true) as HTMLElement;
	}

	private getBreakIndex() {
		const containerWidth = this.element.offsetWidth;
		let cummulatedWidth = this.tabdrop.offsetWidth;
		let index = 0;

		for (const child of this.listChildren) {
			cummulatedWidth += child.offsetWidth;

			if (cummulatedWidth > containerWidth) {
				return index;
			}

			index++;
		}

		return -1;
	}

	private layout() {
		removeClass(this.element, 'is-loading');
		Array.from(this.element.children).forEach(removeClassFactory('d-none'));
		this.itemHolder.innerHTML = '';

		const breakIndex = this.getBreakIndex();

		if (breakIndex === -1) {
			addClass(this.tabdrop, 'd-none');
			return;
		}

		const overlappingChildren = this.listChildren.slice(breakIndex);

		overlappingChildren.forEach((overlapping) =>
			this.itemHolder.appendChild(this.onTransform(overlapping))
		);

		overlappingChildren.forEach(addClassFactory('d-none'));

		if (this.tabdrop.offsetLeft < 250) {
			this.itemHolder.style.left = `${(this.tabdrop.offsetLeft - 15) * -1}px`;
			this.itemHolder.style.right = 'auto';
		} else {
			this.itemHolder.removeAttribute('style');
		}
	}
}
